import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                excel: '#006f00',
                background: '#f1f4f6',
                yellow: '#FFE99E',
                purple_clean: '#E7E1FA'
            },
        },
    },
    
    typography: {
        font: 'Poppins, sans-serif',  // Define a nova fonte global
    },

    // plugins/vuetify.js

    icons: {
        values: {
            pix: {
                component: {
                    name: 'PixIcon',
                    render(h) {
                        return h('svg', {
                            attrs: {
                                xmlns: 'http://www.w3.org/2000/svg',
                                viewBox: '0 0 45 20', // Ajustado para o formato do texto
                                width: '100%',
                                height: '100%',
                                fill: 'currentColor'
                            }
                        }, [
                            h('text', {
                                attrs: {
                                    x: '50%',
                                    y: '50%',
                                    'text-anchor': 'middle',
                                    'dominant-baseline': 'central',
                                    'font-weight': 'bold',
                                    'font-family': 'Poppins, sans-serif', // Usa a fonte que você já definiu
                                    'font-size': '14' // Aumente aqui se precisar de mais destaque
                                }
                            }, 'PIX')
                        ]);
                    }
                }
            },
        },
    },
});
